var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('content-entity-content');
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../../hooks/use-entity';
import { ContentNode } from './content-node';
export var ContentEntityContentDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 300;\n    \n    b, strong {\n      color: ", ";\n    }\n    color: ", ";\n    line-height: 1.45em;\n    /* font-size: ", "; */\n  "], ["\n    font-weight: 300;\n    \n    b, strong {\n      color: ", ";\n    }\n    color: ", ";\n    line-height: 1.45em;\n    /* font-size: ", "; */\n  "])), theme.COLOR('primary'), theme.COLOR('text'), theme.FONT_SIZE(16)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    /* font-size: ", "; */\n  "], ["\n    /* font-size: ", "; */\n  "])), theme.FONT_SIZE(18)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    /* font-size: ", "; */\n  "], ["\n    /* font-size: ", "; */\n  "])), theme.FONT_SIZE(20))
}); // -------- Components -------->

var My = {
  Container: styled(ContentNode)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
/**
 * Displays the `content` field of a `ContentEntity` (e.g. `Page` or `Post`) in a `ContentNode` component
 * (which in turn renders the markdown within the `content` field.)
 */

export var ContentEntityContent = function ContentEntityContent(props) {
  var className = props.className;
  var entity = useEntity(props.entity);
  var content = entity.content;
  return React.createElement(My.Container, {
    entity: content,
    className: cls.name(className)
  });
};
ContentEntityContent.defaultProps = ContentEntityContentDefaultProps;
ContentEntityContent.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;